"use_strict";

const wdtazcakwcbfttehntqqbpqpqnwqkbdb =
{
    values:
    {
        "questions": [
            {
                "id": "q1",
                "type": "radio",
                "order": 1
            },
            {
                "id": "q2",
                "type": "radio",
                "order": 2
            },
            {
                "id": "q3",
                "type": "radio",
                "order": 3
            },
            {
                "id": "q4",
                "type": "radio",
                "order": 4
            },
            {
                "id": "q5",
                "type": "radio",
                "order": 5
            },
            {
                "id": "q6",
                "type": "measurements",
                "order": 6
            },
            {
                "id": "q7",
                "type": "checkbox",
                "order": 7
            }
        ],
        "answers": [
            {
                "id": "q1a1",
                "order": 1,
                "question_id": "q1"
            },
            {
                "id": "q1a2",
                "order": 1,
                "question_id": "q1"
            },
            // {
            //     "id": "q1a3",
            //     "order": 1,
            //     "question_id": "q1"
            // },
            {
                "id": "q1a4",
                "order": 1,
                "question_id": "q1",
                "selection": "Old_Antifouling"
            },
            {
                "id": "q2a1",
                "order": 1,
                "question_id": "q2"
            },
            {
                "id": "q2a2",
                "order": 1,
                "question_id": "q2"
            },
            {
                "id": "q2a3",
                "order": 1,
                "question_id": "q2"
            },
            {
                "id": "q2a4",
                "order": 1,
                "question_id": "q2"
            },
            {
                "id": "q3a1",
                "order": 1,
                "question_id": "q3"
            },
            {
                "id": "q3a2",
                "order": 1,
                "question_id": "q3"
            },
            {
                "id": "q3a3",
                "order": 1,
                "question_id": "q3"
            },
            {
                "id": "q4a1",
                "order": 1,
                "question_id": "q4"
            },
            {
                "id": "q4a2",
                "order": 1,
                "question_id": "q4"
            },
            {
                "id": "q5a1",
                "order": 1,
                "question_id": "q5"
            },
            {
                "id": "q5a2",
                "order": 1,
                "question_id": "q5"
            },
            {
                "id": "q5a3",
                "order": 1,
                "question_id": "q5"
            },
            {
                "id": "q6a1",
                "order": 61,
                "question_id": "q6",
                "type": "measurement_unit"
                ,"boat":"l"
            },
            {
                "id": "q6a2",
                "order": 62,
                "question_id": "q6",
                "type": "measurement_unit"
                ,"boat":"w"
            },
            {
                "id": "q6a3",
                "order": 63,
                "question_id": "q6",
                "type": "measurement_unit"
                ,"boat":"d"
            },
            {
                "id": "q6a4",
                "order": 64,
                "question_id": "q6",
                "selection": [
                    {
                        "label_id": "Motorboot",
                        "value": 1
                    },
                    {
                        "label_id": "Kurzkieler",
                        "value": 0.5
                    },
                    {
                        "label_id": "Langkieler",
                        "value": 0.75
                    },
                    {
                        "label_id": "Kurzkieler_Katamaran",
                        "value": 1
                    },
                    {
                        "label_id": "Langkieler_Katamaran",
                        "value": 1.5
                    }
                ]
            },
            {
                "id": "q7a1",
                "order": 1,
                "question_id": "q7"
            },
            {
                "id": "q7a2",
                "order": 1,
                "question_id": "q7"
            },
            {
                "id": "q7a3",
                "order": 1,
                "question_id": "q7"
            },
            {
                "id": "q7a4",
                "order": 1,
                "question_id": "q7"
            },
            {
                "id": "q7a5",
                "order": 1,
                "question_id": "q7"
            },
            {
                "id": "q7a6",
                "order": 1,
                "question_id": "q7"
            },
            {
                "id": "q7a7",
                "order": 1,
                "question_id": "q7"
            },
            {
                "id": "q7a8",
                "order": 8,
                "question_id": "q7"
            }
        ]
        , "rules": []
        , "instructions": []
        , "products": []
        , "primers": []
        , "primer_recipes": [
            {
                "id": "pr_q1a1i1",
                "primer_id": "pri117",
                "instruction_id": "q1a1i1",
                "layers": 4
            },
            {
                "id": "pr_q1a1i2",
                "primer_id": "pri117",
                "instruction_id": "q1a1i2",
                "layers": 4
            },
            {
                "id": "pr_q1a1i3",
                "primer_id": "pri117",
                "instruction_id": "q1a1i3",
                "layers": 4
            },
            {
                "id": "pr_q1a2i1",
                "primer_id": "pri117",
                "instruction_id": "q1a2i1",
                "layers": 4
            },
            {
                "id": "pr_q1a2i2",
                "primer_id": "pri117",
                "instruction_id": "q1a2i2",
                "layers": 4
            },
            {
                "id": "pr_q1a2i3",
                "primer_id": "pri117",
                "instruction_id": "q1a2i3",
                "layers": 4
            },
            {
                "id": "pr_q1a3i1",
                "primer_id": "pri015",
                "instruction_id": "q1a3i1",
                "layers": 1
            },
            {
                "id": "pr_q1a3i2",
                "primer_id": "pri015",
                "instruction_id": "q1a3i2",
                "layers": 1
            },
            {
                "id": "pr_q1a3i3",
                "primer_id": "priTC",
                "instruction_id": "q1a3i3",
                "layers": 2
            },
            {
                "id": "pr_q1a4i1",
                "primer_id": "pri117",
                "instruction_id": "q1a4i1",
                "layers": 4
            },
            {
                "id": "pr_q1a4o1",
                "primer_id": "pri015",
                "instruction_id": "o1",
                "layers": 1
            },
            {
                "id": "pr_q1a4o2",
                "primer_id": "pri015",
                "instruction_id": "o2",
                "layers": 1
            },
            {
                "id": "pr_q1a4o3",
                "primer_id": "pri015",
                "instruction_id": "o3",
                "layers": 1
            },
            {
                "id": "pr_q1a4o4",
                "primer_id": "pri117",
                "instruction_id": "o4",
                "layers": 4
            }
        ]
    }
}

// @ts-ignore
window.wdtazcakwcbfttehntqqbpqpqnwqkbdb = wdtazcakwcbfttehntqqbpqpqnwqkbdb;
